module.exports = __webpack_public_path__ + "img/1492486851.6991d23f.jpg";